exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Tpk1NiBxj0V6ArlAbSmiH_0{padding:10px;text-align:center}", ""]);

// exports
exports.locals = {
	"feedback_div": "_1Tpk1NiBxj0V6ArlAbSmiH_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d0c5684","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/Feedback.vue
// module id = VaCi
// module chunks = 0